<template>
    <center-layout>
        <v-row
            no-gutters
            align="center"
            justify="center"
            :class="{ 'pb-4': $vuetify.breakpoint.mobile }"
        >
            <v-col>
                <h2 v-text="title" />
                <h3
                    :class="{
                        'pb-4': !$vuetify.breakpoint.mobile,
                        'pb-2': $vuetify.breakpoint.mobile
                    }"
                    v-text="pp_date"
                />
            </v-col>
            <v-col md="2" cols="12" class="text-right">
                <v-btn icon color="red" @click="delete_entry_modal = true">
                    <v-icon>mdi-delete-forever-outline</v-icon>
                </v-btn>
                <v-btn icon :to="`/entries/${$route.params.filename}/edit`">
                    <v-icon color="primary">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon to="/entries/">
                    <v-icon color="primary">mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-divider class="pb-3" />

        <v-progress-linear
            color="primary lighten-1"
            background-color="primary lighten-4"
            indeterminate
            v-if="!data_loaded"
        ></v-progress-linear>

        <vue-markdown
            :source="content"
            :emoji="false"
            :linkify="false"
            v-if="data_loaded"
        />

        <v-dialog width="500" persistent v-model="delete_entry_modal">
            <v-card>
                <v-card-title>
                    Are you sure you want to delete this entry?
                </v-card-title>
                <v-card-text>
                    This action is irreversible, once you delete it, you can
                    <strong>never</strong> recover it.
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        color="primary"
                        @click="delete_entry_modal = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn text color="red" @click="delete_entry">
                        Permanently Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </center-layout>
</template>

<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import { format } from "date-fns";
import VueMarkdown from "vue-markdown";
import CenterLayout from "@/components/CenterLayout.vue";

export default {
    name: "Entries",
    components: {
        VueMarkdown,
        CenterLayout
    },
    data: function() {
        return {
            title: "Loading...",
            content: "One moment, please. Your entry is loading.",
            date_string: format(new Date(), "yyyy-MM-dd"),
            data_loaded: false,
            delete_entry_modal: false,
            filename: "",
            firebase_references: {
                database: null,
                storage: null
            }
        };
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
        pp_date: function() {
            let date_split = this.date_string.split("-"),
                date_object = new Date(
                    Date.UTC(
                        Number(date_split[0]),
                        Number(date_split[1]) - 1,
                        Number(date_split[2]),
                        12,
                        0,
                        0
                    )
                );

            return date_object.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        }
    },
    mounted() {
        this.load_data_dependencies();
        this.fetch_file();
    },
    methods: {
        delete_entry: function() {
            this.delete_entry_modal = false;
            this.firebase_references.database.child(this.filename).remove();
            this.firebase_references.storage
                .child(`${this.filename}.md`)
                .delete();
            this.$router.push({ name: "Entries" });
        },
        fetch_file: function() {
            let data_reference = this.firebase_references.database.child(
                    this.filename
                ),
                file_reference = this.firebase_references.storage.child(
                    `${this.filename}.md`
                );

            data_reference
                .once("value")
                .then(snapshot => snapshot.val())
                .then(data => {
                    this.title = data.title;
                    this.date_string = data.date;
                })
                .catch(error => console.error(error));

            file_reference
                .getDownloadURL()
                .then(url => {
                    fetch(url)
                        .then(response => response.text())
                        .then(data => {
                            this.content = data;
                            this.data_loaded = true;
                        })
                        .catch(error => console.error(error));
                })
                .catch(error => {
                    if (error.code !== "storage/unknown") {
                        this.$router.push({
                            name: "Entries",
                            query: { error: error.code }
                        });
                    } else {
                        console.error(error.code);
                        this.title = "An unknown error occurred";
                        this.content =
                            "# " +
                            error.name +
                            ": " +
                            error.code +
                            "\n### " +
                            error.message;
                    }
                });
        },
        load_data_dependencies: function() {
            this.filename = this.$route.params.filename;
            this.firebase_references.database = firebase
                .database()
                .ref()
                .child(this.user.data.uid);
            this.firebase_references.storage = firebase
                .storage()
                .ref()
                .child(this.user.data.uid);
        },
        human_readable_date: function(date_string) {
            let date_split = date_string.split("-"),
                date_object = new Date(
                    Date.UTC(
                        Number(date_split[0]),
                        Number(date_split[1]) - 1,
                        Number(date_split[2]),
                        12,
                        0,
                        0
                    )
                );

            return date_object.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        }
    }
};
</script>
